export interface TestDetail {
  question: string;
  answer: string;
}

export interface TestContent {
  questions: TestDetail[];
  note: string | null;
}

export interface TestInfo {
  testName: string;
  details: TestContent;
}

export interface WeekData {
  period: string;
  category: string;
  tests: TestInfo[];
}

export const weekGuideData: WeekData[] = [
  {
    period: '1~3주차',
    category: '착상 확인 및 건강 상태 점검',
    tests: [
      {
        testName: '임신 진단용 혈청 hCG 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '혈액 속 hCG(융모성 생식선 자극 호르몬) 수치를 통해 임신 여부를 가장 정확하게 확인할 수 있습니다. 소변 검사보다 민감도가 높아, 아주 초기 단계에서도 임신 여부를 판별할 수 있습니다. 또한 수치 변화 추이를 보면 임신이 정상적으로 유지되고 있는지, 유산 위험은 없는지 파악하는 데 도움이 됩니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '팔에서 혈액을 채취하여 hCG 농도를 분석합니다. 검사 시간은 약 5~10분 정도이며, 특별한 금식이나 사전 준비가 필요하지 않습니다. 결과는 보통 당일 혹은 다음 날 확인할 수 있습니다.',
            },
          ],
          note: '이 검사는 조기 임신 진단의 ‘골드 스탠다드’로 불려요 단 한 번의 수치뿐 아니라, 2~3일 간격으로 반복 검사해 상승 곡선을 확인하면 더 정확한 상태 판단이 가능해요',
        },
      },
      {
        testName: '정밀 초음파',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '자궁 내 착상 여부를 확인하고, 자궁외임신 가능성을 조기에 배제할 수 있습니다. 임신 주차를 보다 정확히 산정하며, 난황(임신낭)과 태아 심박을 확인해 임신 진행 상태를 파악합니다. 조기 발견은 응급 상황을 예방하는 데 중요한 역할을 합니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '임신 초기에는 질 초음파로 진행하는 경우가 많습니다. 초음파 프로브에 커버를 씌우고 젤을 바른 뒤 질 내부에 부드럽게 삽입하여, 고해상도 화면으로 자궁과 난소 상태를 확인합니다. 검사 시간은 약 5~10분이며, 특별한 준비는 필요 없습니다.',
            },
          ],
          note: '정밀 초음파는 단순 확인이 아니라, 임신의 안전성과 향후 관리 방향을 잡는 ‘첫 지도’ 역할이에요. 통증은 거의 없지만 불편감이 있을 수 있어, 긴장을 풀고 호흡을 안정시키면 더 편안하게 받을 수 있어요.',
        },
      },
      {
        testName: '기초 산전 혈액 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신부의 전반적인 건강 상태를 파악해 향후 임신 관리 계획을 세웁니다. 빈혈, 간·신장 기능, 혈액형, 감염병(간염, 매독, HIV 등) 여부를 확인합니다. 조기에 발견하면 치료나 예방 조치를 통해 태아와 산모의 건강을 지킬 수 있습니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '팔에서 혈액을 채취해 여러 항목을 동시에 검사합니다. 금식이 필요한 경우(간 기능, 혈당 검사 포함 시) 검사 전 8시간 금식이 권장됩니다. 검사 결과에 따라 추가 검사나 치료가 결정됩니다.',
            },
          ],
          note: '이 검사는 임신 중 단 한 번이 아니라, 주기적으로 필요할 수 있어요. 특히 감염병 항목은 태아 발달에 큰 영향을 줄 수 있어 초기 확인이 매우 중요해요.',
        },
      },
      {
        testName: '소변검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '초기 임신 여부를 빠르게 확인하고, 집에서도 시행 가능할 수 있습니다. 또 양성 반응 시 조기 진료로 임신 상태를 정확히 파악하기 위해 필요합니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '병원에서 제공한 전용 용기에 소변을 받습니다. 소변은 보통 아침 첫 소변이 정확도가 높습니다. 채취한 소변으로 검사지를 사용하거나, 병원에서 분석 기기에 넣어 확인합니다. 검사 과정은 수 분 내로 끝나며, 특별한 준비가 필요 없습니다.',
            },
          ],
          note: '소변 임신테스트는 첫걸음 검사예요. 결과가 양성이면 가능한 한 빨리 병원에 방문해 정상 임신 여부와 주차를 확인하는 것이 좋습니다.',
        },
      },
      {
        testName: '필요 시 유전자 보인자 선별 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '부부가 특정 유전질환의 보인자인지 확인해, 태아의 유전질환 위험을 사전에 예측합니다. 가족력이나 특정 민족적·지역적 고위험군일 경우 특히 권장됩니다. 예방과 대비를 위해 조기 확인이 중요합니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '주로 혈액을 채취해 DNA를 분석합니다. 일부 경우에는 구강 점막 세포 채취를 통해 진행되기도 합니다. 검사 결과는 1~3주 정도 소요될 수 있습니다.',
            },
          ],
          note: '모든 부부가 필수로 하는 검사는 아니지만, 필요 시 시행하면 불필요한 불안과 위험을 줄일 수 있어요. 결과는 전문 유전상담과 함께 해석하는 것이 좋습니다.',
        },
      },
    ],
  },
  {
    period: '4~6주차',
    category: '임신확인 검사',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '4~6주차에는 초음파로 임신 주수에 맞는 태아의 성장이 이루어지고 있는지 확인해요. 임신이 자궁 내에 정상적으로 진행되고 있는지, 태아의 크기와 심장 박동은 어떠한지도 알 수 있어요.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer: '4~6주차는 질식초음파로 검사가 진행돼요 막대 모양 초음파 기구를 질 안에 삽입해서 자궁을 검사하고, 5-10분 내외로 끝나요.',
            },
          ],
          note: '드디어 출산예정일을 확정할 수 있는 단계예요! 낯선 검사라 경우에 따라 불편한 느낌이 들 수는 있지만, 신호에 맞춰서 숨을 들이쉬고 내쉬면 나아질 거예요',
        },
      },
      {
        testName: '경부암 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신 중에도 자궁경부암은 발생할 수 있습니다. 초기에 발견하면 대부분 치료가 가능하지만, 진행된 후에는 치료가 더 어려워집니다. 산부인과 방문 시 정기 검진과 함께 진행하면 시간과 노력을 절약할 수 있습니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '산부인과 진찰 중, 브러시 형태의 기구로 자궁경부의 세포를 살짝 채취합니다. 채취한 세포를 현미경으로 관찰해 암세포나 전암 상태 여부를 확인합니다. 검사 과정은 짧고, 통증은 거의 없습니다. 드물게 소량의 출혈이 있을 수 있지만, 대부분 일시적입니다.',
            },
          ],
          note: '임신은 아기를 위한 준비이자, 엄마 스스로의 건강을 지키는 시기이기도 합니다. 정기 검진과 함께 자궁경부암 검사를 받는다면, 출산 후에도 건강하게 아기를 돌볼 수 있는 기반이 됩니다.',
        },
      },
      {
        testName: '혈액 임신호르몬 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신 호르몬 검사는 초음파에서 정상 임신인지가 명확하지 않을 때 진단에 도움이 됩니다. 자궁 외 임신, 유산 등을 감별할 때에도 유용한 검사이니 필요 시 권고드려요.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '일반적인 혈액검사와 동일합니다. 혈관에서 소량의 혈액을 채취해 검사 용기에 담습니다. 특별한 사전 준비는 필요하지 않습니다. 채혈 시간은 1분 이내로 짧고, 대부분 통증은 경미합니다. 경우에 따라 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '이 검사는 아기의 상태뿐 아니라 임신이 안전하게 진행되고 있는지를 확인하는 중요한 자료가 됩니다. 필요 시 주저하지 말고 의료진과 상의해 진행하는 것이 좋습니다.',
        },
      },
      {
        testName: '소변 임신테스트 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '초기 임신 여부를 빠르게 확인하고, 집에서도 시행 가능할 수 있습니다. 또 양성 반응 시 조기 진료로 임신 상태를 정확히 파악하기 위해 필요합니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '병원에서 제공한 전용 용기에 소변을 받습니다. 소변은 보통 아침 첫 소변이 정확도가 높습니다. 채취한 소변으로 검사지를 사용하거나, 병원에서 분석 기기에 넣어 확인합니다. 검사 과정은 수 분 내로 끝나며, 특별한 준비가 필요 없습니다.',
            },
          ],
          note: '소변 임신테스트는 첫걸음 검사예요. 결과가 양성이면 가능한 한 빨리 병원에 방문해 정상 임신 여부와 주차를 확인하는 것이 좋습니다.',
        },
      },
    ],
  },
  {
    period: '7~9주',
    category: '초기 검사',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '아기가 자궁 내에 정상적으로 자리 잡았는지 확인하고, 태아 크기와 성장 정도를 알 수 있어요. 심장 박동도 확인하고, 출산 예정일을 드디어 계산할 수 있답니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '질식초음파 방식으로 진행됩니다. 막대 모양의 탐촉자를 질 안에 삽입하여 자궁과 아기의 상태를 관찰합니다. 기구에는 윤활제를 바른 후 위생 커버를 씌워 사용하며, 대부분 통증 없이 5~10분 내외로 끝납니다. 간혹 약간의 불편함이 있을 수 있지만, 호흡을 고르게 하면 한결 편안하게 진행됩니다.',
            },
          ],
          note: '이 검사는 아기의 발달뿐 아니라 앞으로의 임신 관리 계획을 세우는 출발점이 됩니다. 검사 전 궁금한 점이 있다면 미리 메모해두었다가 의료진과 상의하는 것이 좋습니다.',
        },
      },
      {
        testName: '일반 혈액검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '빈혈 여부를 확이낳고, 혈소판 감소증 및 다른 혈액질환 조기 발견할 수 있어요. 치료나 보충이 필요한 경우 빠른 대처도 가능합니다. 검사 결과지를 받으면 빈혈 수치와 혈소판 수치는 꼭 기억해 두세요.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '채혈실에서 혈관에서 소량의 혈액을 채취합니다. 별도의 준비는 필요하지 않습니다. 채혈 시간은 1분 내외이며, 경우에 따라 5분 정도 지혈할 수 있습니다. 주사에 대한 두려움이 있더라도 짧고 간단하게 끝나는 검사입니다.',
            },
          ],
          note: '빈혈은 임신 기간 동안 악화될 수 있으므로, 정기적인 수치 확인이 필요합니다. 철분 보충제를 복용할 때는 의사의 권장 용량과 방법을 따르세요. 검사 후 어지러움이나 멍울이 생기면, 해당 부위를 부드럽게 마사지하거나 냉찜질을 해주세요.',
        },
      },
      {
        testName: '혈액형(ABO/Rh) 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '아기가 Rh 음성이라면 태아 용혈 증후군이 올 수 있는데, 혈액형 검사를 통해 용혈현상으로 인한 유산·조산·사산 위험을 예방할 수 있어요. 태아 용혈 증후군의 경우 조기 대응이 가능하고, 분만 및 임신 중 필요한 처치를 준비하기 위해서도 필요해요.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '채혈실에서 혈관에서 소량의 혈액을 채취합니다. 별도의 준비는 필요 없습니다. 채혈은 약 1분 내외로 끝나며, 경우에 따라 5분 정도 지혈할 수 있습니다. 통증이 심하지 않고 짧게 끝나는 안전한 검사입니다.',
            },
          ],
          note: '혈액형은 임신 관리뿐 아니라 응급 상황에서도 중요한 정보이니 결과를 반드시 기록해 두세요. Rh 음성 판정을 받으면 의료진과 향후 관리 계획(주사, 약물, 수혈)을 상의하세요. 과거 수혈 이력이나 혈액 관련 질환이 있다면 검사 전 반드시 알려주세요.',
        },
      },
      {
        testName: '불규칙 항체 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '수혈 전 비예기항체 존재 여부를 확인하고, 태아 용혈 증후군 위험 사전 차단할 수 있어요. 안전한 분만과 수혈을 준비하고, 항체 발견 시 추가 검사(항체동정검사)로 특이성을 파악할 수 있습니다.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '채혈실에서 혈액을 소량 채취합니다. 별도 준비 없이 간단히 진행됩니다. 혈액형(ABO/Rh) 검사에서 확장된 검사이며,Rh 이 외의 불규칙 항체가 발견되면 항체동정검사를 추가로 시행합니다. 항체 특이성이 임상적으로 의미가 있을 경우, 해당 항원이 없는 혈액을 찾아 교차시험을 거친 뒤 수혈을 진행합니다.',
            },
          ],
          note: '수혈 전 불규칙 항체 검사는 필수 절차입니다. 검사 결과에 따라 추가 검사와 특수한 혈액 준비가 필요할 수 있습니다. 과거 수혈 이력이나 항체 관련 진단을 받은 적이 있다면 미리 의료진에게 알리세요.',
        },
      },
      {
        testName: '간기능 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '간질환은 뱃속 아기에게까지 영향을 줄 수 있습니다. 바이러스성 간염이 있다면 조산, 사산, 미숙아 출산 위험이 높아지고, 임신 후기 간질환은 아기 성장 지연이나 돌연사 같은 심각한 결과로 이어질 수 있습니다. 간이 건강하면 분만 시 마취와 해독작용이 원활해져 산모와 아기 모두 안전해집니다. 건강한 출산을 위해 반드시 필요한 검사입니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도 준비 없이 채혈실에서 진행하며, 1분 내에 끝납니다. 경우에 따라 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '임신 중 간 건강은 아기 성장과 분만 안전에 직결됩니다. 간기능 수치 이상 시, 반드시 전문의 상담과 추가 관리가 필요합니다.',
        },
      },
      {
        testName: '갑상선기능 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '갑상선 호르몬은 아기의 뇌 발달과 성숙에 매우 중요한 역할을 합니다. 산모의 갑상선 기능에 이상이 있으면 유산 위험이 높아질 수 있어, 조기에 이상을 발견하고 내과 등과 협진하는 것이 중요합니다. 따라서 갑상선 기능 검사는 임신 초기 필수 검사입니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비는 필요하지 않으며, 채혈실에서 1분 내외로 끝납니다. 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '갑상선 기능 이상은 임신과 아기 건강에 직접적인 영향을 미치므로, 정기적인 검사와 관리가 필요합니다. 검사 결과에 따라 추가 진료와 치료가 진행될 수 있습니다.',
        },
      },
      {
        testName: 'B형 간염 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                'B형 간염 보균자나 활동성 간염 상태인 산모는 출산 과정에서 아기가 감염될 위험이 있습니다. 태어난 아기가 감염되면 건강에 큰 영향을 미칠 수 있으나, 출산 직후 간염 예방접종과 면역 글로불린 주사를 통해 예방이 가능합니다. 따라서 산모가 B형 간염 보균자인지 여부를 조기에 확인하는 것이 매우 중요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사가 완료됩니다. 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: 'B형 간염 검사를 통해 산모와 아기의 건강을 지키는 첫걸음을 내딛게 됩니다. 보균자나 활동성 간염 판정 시, 의료진과 예방 및 치료 계획을 반드시 상의하세요.',
        },
      },
      {
        testName: '풍진항체 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신 12주 이내에 산모가 풍진에 감염되면 태아 감염 확률이 약 80%에 달합니다. 감염된 태아의 약 85%는 백내장, 선천성 심장병 등 선천성 기형을 갖게 될 위험이 매우 높습니다. 풍진항체 검사는 산모가 풍진에 대한 면역이 있는지 여부를 확인할 수 있어, 필요 시 예방접종 또는 추가 관리를 계획하는 데 꼭 필요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사가 완료됩니다. 경우에 따라 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '풍진항체 검사 결과에 따라 면역이 부족할 경우 예방접종을 권유받을 수 있습니다. 임신 계획 전이나 임신 초기 반드시 검사해 태아 건강을 지키는 것이 중요합니다.',
        },
      },
      {
        testName: 'C형 간염 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '산모가 과거에 간염을 앓았거나 활동성 간염 상태라면, 아기가 C형 간염에 감염될 위험이 있습니다. 따라서 C형 간염 검사를 통해 조기에 상태를 확인하고, 아기의 감염 위험을 줄이는 예방 조치를 하는 것이 매우 중요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사가 완료됩니다. 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: 'C형 간염 감염 여부 확인은 산모와 아기 모두의 건강을 지키는 첫걸음입니다. 검사 결과에 따라 추가 검사나 치료가 필요할 수 있으니, 의료진과 상담하세요.',
        },
      },
      {
        testName: '매독 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '매독은 임신 중 감염 시 조산, 유산, 사산 위험이 높아질 뿐 아니라, 아기도 선천적으로 매독에 감염될 수 있는 매우 위험한 성병입니다. 임신 16주 이내에 치료하면 태아 감염을 예방할 수 있으므로, 조기 검사를 통해 안전한 임신을 준비하는 것이 매우 중요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사하며, 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '매독 검사는 산모와 태아 건강 보호를 위한 필수 검사입니다. 검사 결과에 따라 신속한 치료가 진행될 수 있도록 의료진과 상담하세요.',
        },
      },
      {
        testName: '에이즈 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '에이즈(HIV)는 임신 중 엄마로부터 태아나 신생아에게 감염될 수 있는 심각한 질환입니다. 조기에 진단하지 않으면 아기가 골수억제, 빈혈 등 심각한 합병증을 겪거나 자궁 내 사망에 이를 수 있으므로, 임신 초기 에이즈 검사는 산모와 아기의 건강을 지키기 위해 꼭 필요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사하며, 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '에이즈 검사는 임신 중 감염 예방과 조기 치료를 위한 필수 검사입니다. 검사 결과에 따라 신속하게 의료진과 상담하고 필요한 조치를 받으세요.',
        },
      },
      {
        testName: '소변 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '소변 검사를 통해 임신 중에 당뇨나 단백뇨가 있는지 알아볼 수 있어요. 또 소변 감염이 있으면 방광이나 신장에 문제가 생길 수도 있기 때문에 엄마와 아기의 건강을 지키는 데 꼭 필요한 검사랍니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '병원에서 드리는 용기에 화장실에서 소변을 받아 오시면 돼요. 처음 나오는 소변 30ml 정도는 살짝 버리고, 그 다음 30~50ml 정도만 받아주세요. 검사 전에는 주스나 콜라처럼 달콤한 음료는 잠시 참아주시면 좋아요.',
            },
          ],
          note: '이 검사는 우리 아기와 엄마의 건강을 꼼꼼히 살피는 따뜻한 배려랍니다. 검사 전 달콤한 음료는 잠깐 멀리해 주세요. 그래야 더 정확한 결과를 얻을 수 있어요.',
        },
      },
      {
        testName: '성병균 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '성병균 검사는 건강한 아기를 맞이하기 위해 꼭 필요한 검사입니다. 특히, 클라미디아균은 조산과 아기의 각막염을 일으킬 수 있고, 유레아플라즈마균은 조산, 사산, 저체중아 출산, 양수양막염을 유발할 수 있으며, 트리코모나스는 태반 조기 박리와 조산 위험을 높이고, 임질은 유산, 조산, 융모양막염, 산욕기 감염을 일으킬 수 있습니다. 마이코플라즈마 제니탈리움은 유산 위험과 관련되어 있어요. 이런 감염을 미리 확인해 치료하는 것이 엄마와 아기 건강에 큰 도움이 될 거예요',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '질경을 넣고, 특수한 브러시로 질 분비물을 부드럽게 채취합니다. 채취한 샘플로 성병균 유무를 검사하게 됩니다. 검사 과정은 짧고 편안하게 진행되니 걱정하지 않으셔도 됩니다.',
            },
          ],
          note: '이 검사는 엄마와 우리 아기를 위해 꼭 필요한 검사예요. 검사 결과가 나오면, 의료진과 함께 차근차근 잘 이야기 나누며 건강한 임신을 이어가길 응원할게요. 너무 걱정하지 말고 마음 편히 검사받으세요.',
        },
      },
      {
        testName: '비타민D 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '우리 엄마와 아기의 뼈 건강을 위해 비타민D 수치는 정말 중요해요. 비타민D는 칼슘 흡수를 도와 튼튼한 뼈를 만드는 데 꼭 필요하답니다. 혈중 비타민D가 부족하면 조산 위험이 약 1.5배나 높아질 수 있어서 꼼꼼히 검사하고 관리하는 것이 안전한 임신을 위한 첫걸음이에요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사하며, 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '이 검사는 엄마와 아기의 건강을 위한 아주 소중한 배려입니다. 검사 결과에 따라 필요한 영양 관리나 치료를 의료진과 함께 천천히 계획해 나가세요. 마음 편하게 검사받으시고, 건강한 하루하루 보내시길 늘 응원할게요.',
        },
      },
    ],
  },
  {
    period: '10~14주',
    category: '초기 기형아 검사',
    tests: [
      {
        testName: '정밀 초음파 검사(목투명대)',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '우리 아기가 건강하게 자라고 있는지 궁금하고, 걱정이 많으실 거예요. 통합적 검사는 아기의 건강 상태를 한눈에 확인할 수 있는 중요한 첫걸음입니다. 그 중 정밀초음파 검사를 통해 아기의 목 뒤, 즉 목투명대를 측정해요. 목투명대가 두꺼운 경우에는 염색체 이상이나 구조적 문제가 있을 수 있어 필요 시 추가 검사가 권장될 수 있습니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '이제부터는 배 위에서 하는 복부초음파로 검사가 이루어집니다. 침대에 편히 누우시고, 배에 윤활제를 바른 뒤 초음파 기구를 움직여 아기를 살펴보게 돼요. 숨을 깊이 들이쉬고 내쉬는 신호에 맞춰 천천히 호흡해 주세요. 검사 시간은 약 10분 정도로, 통증 없이 편안하게 진행됩니다.',
            },
          ],
          note: '검사 결과는 의료진과 함께 꼼꼼히 확인하고 궁금한 점은 편하게 상담하세요. 걱정되는 마음 조금 내려놓으시고, 편안한 마음으로 아기와의 만남을 준비해 가시길 바랍니다.',
        },
      },
      {
        testName: 'PAPP-A',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '이 검사는 태반에서 만들어져 모든 임산부 혈액에 존재하는 정상 단백질을 측정해요. 이를 통해 다운증후군 등 염색체 이상으로 인한 태아 기형 위험을 파악할 수 있답니다. 혈액검사 결과와 아기의 목투명대 두께를 함께 확인하면 초기 기형아 검사가 완성돼요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '채혈실에서 간단히 혈관에서 혈액을 채취하는 검사입니다. 별도의 준비물 없이 방문하시면 되고, 검사 시간은 1분 내외로 아주 빠르게 끝나요. 주사 바늘에 긴장되실 수 있지만, 걱정하지 마세요. 금방 끝나니까요! 검사 후에는 필요에 따라 5분 정도 지혈을 할 수도 있습니다.',
            },
          ],
          note: '검사 결과는 의료진과 함께 차분히 상담하며 이해하시면 좋아요. 마음 편히 검사받으시고, 아기와 건강한 시간을 보내시길 진심으로 응원합니다.',
        },
      },
      {
        testName: 'NIPT(G-NIPT,CHA-NIPT...)',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                'NIPT(비침습적 산전 유전자 검사)는 임신 초기에 태아의 다운증후군, 에드워드 증후군 등 염색체 이상 위험을 빠르고 안전하게 확인할 수 있는 검사입니다. 35세 이상 고령 산모나 쿼드 테스트 결과 고위험군인 경우 특히 권장되며, 기존 침습 검사에 비해 위험 부담이 없고 정확도가 매우 높아 최근 많이 선택되고 있습니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '간단한 혈액검사로, 임신 10주 차 이후에 시행할 수 있습니다. 한 번의 채혈로 태아 DNA를 분석하며, 결과는 보통 2~4일 내에 받아볼 수 있습니다. 검사 시간은 1분 내외로 매우 간단하며, 추가 준비나 주의사항도 특별히 필요하지 않습니다.',
            },
          ],
          note: '이 검사는 우리 아기 건강을 미리 확인하는 소중한 기회입니다. 검사 결과가 나올 때까지 너무 걱정하지 마시고, 궁금한 점이나 불안한 마음은 언제든 의료진과 편안하게 상담해 보세요. 여러분의 마음과 아기의 건강을 함께 응원할게요.',
        },
      },
      {
        testName: '융모막 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '융모막 검사는 아기의 염색체 이상을 확진할 수 있는 중요한 검사입니다. 태반에서 유래한 융모막 조직이 아기와 거의 같은 염색체를 가지고 있어, 이를 채취해 검사하면 염색체나 DNA 이상을 정확히 알 수 있답니다. 특히 9주부터 시행 가능해 조기에 진단할 수 있다는 장점이 있지만, 태아 손실 위험이 1.5~3% 정도 있으니 신중한 결정이 필요해요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '먼저 초음파로 아기 상태와 융모막 위치를 확인한 뒤, 마취를 하고 검사를 시작합니다. 융모막 위치에 따라 자궁경관을 통해 가는 관으로 조직을 채취하거나, 복벽을 통해 주사침으로 조직을 흡입하는 방법이 있어요. 검사 중에는 약간의 압력이나 불편함이 있을 수 있지만, 대부분 큰 통증 없이 끝납니다.',
            },
          ],
          note: '검사 전에는 아침 식사 후 음료만 섭취하시고 방광을 채워서 오시면 검사에 도움이 돼요. 혈액형이 Rh 음성일 경우 추가로 면역 글로불린 주사를 맞아야 하니 미리 알려주세요. 검사 후에는 하루 정도 편안히 쉬시고, 며칠간 무리한 활동과 성관계, 탐폰 사용은 피하는 것이 좋아요. 조금 불편하시더라도 아기와 엄마의 안전을 위한 과정임을 꼭 기억해주세요. 언제나 건강하고 행복한 임신을 응원합니다.',
        },
      },
    ],
  },
  {
    period: '15~20주',
    category: '임신 중기 기형아 검사',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '이제 임신 15~20주차, 우리 아기가 한층 더 자라고 있는 시기예요. 초음파 검사를 통해 아기의 크기, 체중뿐만 아니라 양수 양과 태반 위치까지 꼼꼼히 확인할 수 있답니다. 건강한 임신과 출산을 위해 꼭 필요한 검사이니 안심하고 받으세요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '복부초음파 검사로, 엄마의 배 위 피부에 초음파 기구를 움직이며 아기를 관찰합니다. 병원의 안내에 따라 침대에 누워 피부에 윤활제를 바르고 검사해요. 검사 중에는 천천히 숨을 들이쉬고 내쉬면 되니 걱정 마세요. 10분 정도면 끝나며 통증 없이 편안하게 진행됩니다.',
            },
          ],
          note: '아기의 건강 상태를 직접 눈으로 확인하는 소중한 시간이니 마음을 편안히 가지세요. 초조하거나 긴장되더라도 아기가 잘 자라고 있다는 좋은 신호이니 안심하셔도 괜찮아요. 엄마와 아기 모두 행복하고 건강한 임신 기간 보내시길 진심으로 응원합니다!',
        },
      },
      {
        testName: 'Quad Test',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                'Quad Test는 우리 아기의 염색체 이상 가능성을 확인하는 중요한 검사예요. 결과에 ‘고위험군’이라는 단어가 있어 많이 놀라실 수 있지만, 이건 확진이 아닌 가능성일 뿐이랍니다. 고위험군이면 추가 검사가 필요하다는 뜻이고, 저위험군이라도 가능성이 아주 낮다는 뜻이지 100% 안전하다는 뜻은 아니에요. 검사 결과가 정상이어도 드물게 기형이 발견될 수 있으니 너무 걱정하지 마세요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 아주 간단한 검사예요. 채혈실에서 1분 내외로 끝나고, 검사 후 5분 정도 지혈이 필요할 수 있습니다. 주사 맞는 게 무섭더라도 금세 끝나니 걱정 마세요!',
            },
          ],
          note: '이 검사는 아기 건강을 지키기 위한 첫걸음이에요. 결과가 나오면 의료진과 충분히 상담하며 다음 단계를 함께 계획하세요. 몸도 마음도 편안해질 수 있도록 늘 응원할게요!',
        },
      },
      {
        testName: '양수 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '양수 검사는 아기의 염색체 이상 여부를 확실히 확인하는 중요한 검사입니다. 특히 고위험군이거나 가족력이 있는 경우, 또는 초음파 등에서 이상이 의심될 때 꼭 필요한 검사예요. 우리 아기의 건강 상태를 정확히 알 수 있어, 필요한 치료나 관리 계획을 세울 수 있다는 점에서 큰 도움이 된답니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '초음파를 보면서 복부를 통해 자궁 안의 양수 20~30cc를 채취하는 검사예요. 안전한 방법이지만 검사 전에 소변을 참아 방광을 채워두면 영상이 더 잘 보여요. 검사 후에는 하루 정도 푹 쉬시고, 통증이나 열, 출혈 같은 이상 증상이 있으면 즉시 병원에 알려주세요.',
            },
          ],
          note: '검사 과정이 낯설고 걱정될 수 있지만, 우리 아기의 건강을 위해 꼭 필요한 검사랍니다. 언제나 의료진과 충분히 상담하시고, 마음 편히 쉬면서 건강을 잘 챙기시길 응원할게요!',
        },
      },
    ],
  },
  {
    period: '21~24주',
    category: '정밀 초음파 검사',
    tests: [
      {
        testName: '정밀 초음파 검사 (태아 심장 초음파)',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '정밀 초음파 검사는 아기의 주요 기형 여부를 약 70%까지 진단할 수 있는 매우 중요한 검사입니다. 특히 아기의 생명에 영향을 줄 수 있는 기형들은 거의 정확히 발견할 수 있어, 만약 문제가 있으면 출산 직후 신속한 의료 처치가 가능하도록 미리 준비할 수 있답니다. 우리 아기의 건강과 안전을 위해 꼭 받으시는 걸 추천드려요!',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '배 위에 윤활제를 바르고 초음파 기구를 이용해 뱃속 아기를 자세히 살펴보는 복부초음파 검사입니다. 검사 시간은 약 20분에서 1시간 정도 걸릴 수 있어요. 검사 시간이 길다고 해서 아기 건강에 문제가 있는 것은 아니니 걱정 마시고 편안한 마음으로 검사 받으세요. 이번 검사를 통해 다양한 기형 여부를 꼼꼼히 확인할 수 있답니다.',
            },
          ],
          note: '검사 시간이 길어질 수 있지만, 이는 아기를 더 세심히 관찰하기 위함이에요. 궁금한 점이나 불안한 마음은 언제든 의료진과 나누시고, 우리 아기와 건강을 위해 잘 챙기시길 늘 응원할게요!',
        },
      },
    ],
  },
  {
    period: '25~28주',
    category: '임신성 당뇨 검사',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '이제 다시 우리 아기를 볼 시간이에요! 아기가 얼마나 건강하게 자라고 있는지, 체중은 잘 늘고 있는지 궁금하고 걱정되는 마음, 모두 이해해요. 복부초음파 검사를 통해 아기의 모습을 직접 확인하고, 양수 양과 태반 위치도 함께 점검할 수 있어요. 우리 아기의 건강 상태를 안심할 수 있는 소중한 시간이 될 거예요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '배 위에 윤활제를 바르고 초음파 기구를 움직이며 뱃속 아기를 살펴보는 복부초음파 검사입니다. 병원의 안내에 따라 침대에 편안히 누워 숨을 깊게 들이쉬고 내쉬는 것만 신경 써 주세요. 검사 시간은 약 10분 정도로 통증 없이 진행되니 걱정하지 않으셔도 됩니다. 화면을 통해 우리 아기의 건강한 모습을 보면서 마음도 편안해지실 거예요.',
            },
          ],
          note: '아기의 건강을 확인하는 소중한 시간이니 긴장하지 말고 편안한 마음으로 검사에 임해주세요. 궁금한 점이 있으면 언제든지 의료진에게 물어보시고, 우리 아기와 건강을 위해 잘 챙기시길 늘 응원할게요!',
        },
      },
      {
        testName: '3D(입체) 초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '아기를 만나는 그날을 손꼽아 기다리시죠? 3D 초음파 검사는 아기의 얼굴, 손가락, 발가락, 팔, 다리까지 더 선명하고 입체적으로 볼 수 있는 특별한 시간이랍니다. 꼬물꼬물 움직이는 귀여운 우리 아기의 모습을 직접 확인하며 따뜻한 순간을 느껴보세요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '복부초음파로 배 위에 초음파 기구를 부드럽게 움직이며 아기를 살펴보는 검사예요. 병원의 안내에 따라 침대에 누워 배에 윤활제를 바르고, 숨을 천천히 들이쉬고 내쉬시면 됩니다. 10분 내외로 통증 없이 편안하게 진행되니 걱정하지 않으셔도 돼요.',
            },
          ],
          note: '우리 아기의 사랑스러운 모습을 만나는 소중한 시간이니 편안한 마음으로 검사에 임해 주세요. 궁금한 점은 언제든지 의료진에게 물어보시고, 건강과 행복을 늘 응원할게요!',
        },
      },
      {
        testName: '50gm OGTT',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신성당뇨는 임신 중에 새롭게 나타나는 당뇨병으로, 우리 아기와 엄마의 건강에 영향을 줄 수 있어요. 특히 임신성당뇨가 있으면 출산 전후 여러 문제가 생길 수 있으니 꼭 검사하고 관리하는 게 중요하답니다. 50g 당부하검사(OGTT)는 당 섭취 후 1시간 뒤 혈당 수치를 재어 임신성당뇨 여부를 쉽게 확인할 수 있어요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '익숙한 혈액검사 방법으로, 혈관에서 혈액을 소량 채취하는 간단한 검사예요. 채혈실에서 1분 내외로 금방 끝나고, 검사 후 약간의 지혈 시간이 필요할 수 있어요. 주사 공포증이 있어도 걱정 마세요! 금방 끝나니까요.',
            },
          ],
          note: '임신성당뇨 검사는 엄마와 아기의 건강을 지키는 소중한 단계랍니다. 검사 결과에 따라 의료진과 함께 필요한 관리 방법을 잘 상담해 보시고, 마음 편히 건강한 임신 기간 보내시길 응원할게요!',
        },
      },
      {
        testName: '빈혈 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '임신 중 갑자기 찾아오는 빈혈은 큰 피로와 불편을 줄 수 있어요. 빈혈이 심해지면 두통이나 무기력함이 심해지고, 우리 아기에게도 필요한 철분 공급이 부족해질 수 있답니다. 또 분만 시 수혈이 필요할 수도 있어서 꼭 미리 검사하고 관리하는 게 안전해요. 빈혈은 식사만으로 완전히 해결하기 어렵기 때문에 철분제를 꾸준히 복용하는 것이 가장 효과적인 치료법이에요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '익숙한 혈액검사로, 혈관에서 소량의 혈액을 채취하는 간단한 검사예요. 준비물 없이 채혈실에서 1분 정도면 끝나고, 경우에 따라 검사 후 5분 정도 지혈이 필요할 수도 있어요. 주사 바늘이 무서워도 걱정하지 마세요. 금방 끝난답니다!',
            },
          ],
          note: '빈혈 검사는 엄마의 건강과 우리 아기의 안전을 위한 중요한 검사예요. 검사 결과를 바탕으로 필요한 치료와 영양 관리를 의료진과 함께 차근차근 계획해 나가시면 좋겠어요. 편안한 마음으로 검사받으시고 건강한 하루하루 보내시길 늘 응원할게요!',
        },
      },
      {
        testName: '소변 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '소변 검사를 통해 임신 중에 당뇨나 단백뇨가 있는지 알아볼 수 있어요. 또 소변 감염이 있으면 방광이나 신장에 문제가 생길 수도 있기 때문에 엄마와 아기의 건강을 지키는 데 꼭 필요한 검사랍니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '병원에서 드리는 용기에 화장실에서 소변을 받아 오시면 돼요. 처음 나오는 소변 30ml 정도는 살짝 버리고, 그 다음 30~50ml 정도만 받아주세요. 검사 전에는 주스나 콜라처럼 달콤한 음료는 잠시 참아주시면 좋아요.',
            },
          ],
          note: '이 검사는 우리 아기와 엄마의 건강을 꼼꼼히 살피는 따뜻한 배려랍니다. 검사 전 달콤한 음료는 잠깐 멀리해 주세요. 그래야 더 정확한 결과를 얻을 수 있어요.',
        },
      },
    ],
  },
  {
    period: '29~34주',
    category: '정기 검진',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '이제 다시 우리 아기를 볼 시간이 되었어요. 아기가 잘 자라고 있는지, 체중은 적당한지 궁금하고 걱정되시죠? 초음파 검사를 통해 우리 아기의 모습을 직접 확인하며, 양수의 양과 태반 위치도 함께 점검할 수 있답니다. 안심할 수 있는 좋은 기회니까 편안한 마음으로 검사에 임해 주세요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '복부 초음파로 검사를 진행해요. 배 위에 윤활제를 바르고 초음파 기구를 부드럽게 움직이며 아기의 모습을 살펴볼 거예요. 병원 안내에 따라 침대에 누워서 편안한 자세를 취해 주시고, 신호에 맞춰 숨을 천천히 들이쉬고 내쉬시면 돼요. 10분 정도면 검사 끝나고, 통증도 없으니 걱정하지 마세요.',
            },
          ],
          note: '아기의 건강한 모습을 직접 확인하는 소중한 시간이니, 마음을 편안히 가지시고 검사를 받아 주세요. 언제나 마미님과 아기의 안전과 행복을 응원하고 있답니다!',
        },
      },
    ],
  },
  {
    period: '35~36주',
    category: '출산 전 산모 종합검사',
    tests: [
      {
        testName: '일반 혈액검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '빈혈 여부를 확이낳고, 혈소판 감소증 및 다른 혈액질환 조기 발견할 수 있어요. 치료나 보충이 필요한 경우 빠른 대처도 가능합니다. 검사 결과지를 받으면 빈혈 수치와 혈소판 수치는 꼭 기억해 두세요.',
            },
            {
              question: '검사는 어떻게 진행되나요?',
              answer:
                '채혈실에서 혈관에서 소량의 혈액을 채취합니다. 별도의 준비는 필요하지 않습니다. 채혈 시간은 1분 내외이며, 경우에 따라 5분 정도 지혈할 수 있습니다. 주사에 대한 두려움이 있더라도 짧고 간단하게 끝나는 검사입니다.',
            },
          ],
          note: '빈혈은 임신 기간 동안 악화될 수 있으므로, 정기적인 수치 확인이 필요합니다. 철분 보충제를 복용할 때는 의사의 권장 용량과 방법을 따르세요. 검사 후 어지러움이나 멍울이 생기면, 해당 부위를 부드럽게 마사지하거나 냉찜질을 해주세요.',
        },
      },
      {
        testName: '간기능 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '간질환은 뱃속 아기에게까지 영향을 줄 수 있습니다. 바이러스성 간염이 있다면 조산, 사산, 미숙아 출산 위험이 높아지고, 임신 후기 간질환은 아기 성장 지연이나 돌연사 같은 심각한 결과로 이어질 수 있습니다. 간이 건강하면 분만 시 마취와 해독작용이 원활해져 산모와 아기 모두 안전해집니다. 건강한 출산을 위해 반드시 필요한 검사입니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도 준비 없이 채혈실에서 진행하며, 1분 내에 끝납니다. 경우에 따라 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '임신 중 간 건강은 아기 성장과 분만 안전에 직결됩니다. 간기능 수치 이상 시, 반드시 전문의 상담과 추가 관리가 필요합니다.',
        },
      },
      {
        testName: '전해질 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '‘전해질’이라는 말이 생소하게 느껴질 수 있지만, 우리 몸에서 아주 중요한 역할을 한답니다. 전해질은 몸의 대사 과정과 균형을 조절해서 건강을 지키는 데 꼭 필요해요. 이 검사를 통해 전해질 불균형으로 인한 여러 건강 문제를 미리 알아내고, 필요한 조치를 계획할 수 있답니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '이미 여러 번 해보셨을 혈액검사와 같아요! 혈관에서 소량의 혈액을 채취해서 검사하는 간단한 과정이랍니다. 준비물도 따로 없고, 1분 정도면 눈 깜짝할 사이에 끝나니까 너무 걱정하지 마세요. 검사 후에는 경우에 따라 5분 정도 지혈이 필요할 수 있어요.',
            },
          ],
          note: '엄마와 아기의 건강을 지키는 소중한 검사입니다. 편안한 마음으로 검사에 임하시고, 언제나 응원할게요!',
        },
      },
      {
        testName: '매독 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '매독은 임신 중 감염 시 조산, 유산, 사산 위험이 높아질 뿐 아니라, 아기도 선천적으로 매독에 감염될 수 있는 매우 위험한 성병입니다. 임신 16주 이내에 치료하면 태아 감염을 예방할 수 있으므로, 조기 검사를 통해 안전한 임신을 준비하는 것이 매우 중요합니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취하는 간단한 혈액검사입니다. 별도의 준비 없이 채혈실에서 1분 내외로 검사하며, 검사 후 5분 정도 지혈이 필요할 수 있습니다.',
            },
          ],
          note: '매독 검사는 산모와 태아 건강 보호를 위한 필수 검사입니다. 검사 결과에 따라 신속한 치료가 진행될 수 있도록 의료진과 상담하세요.',
        },
      },
      {
        testName: '소변 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '소변 검사를 통해 임신 중에 당뇨나 단백뇨가 있는지 알아볼 수 있어요. 또 소변 감염이 있으면 방광이나 신장에 문제가 생길 수도 있기 때문에 엄마와 아기의 건강을 지키는 데 꼭 필요한 검사랍니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '병원에서 드리는 용기에 화장실에서 소변을 받아 오시면 돼요. 처음 나오는 소변 30ml 정도는 살짝 버리고, 그 다음 30~50ml 정도만 받아주세요. 검사 전에는 주스나 콜라처럼 달콤한 음료는 잠시 참아주시면 좋아요.',
            },
          ],
          note: '이 검사는 우리 아기와 엄마의 건강을 꼼꼼히 살피는 따뜻한 배려랍니다. 검사 전 달콤한 음료는 잠깐 멀리해 주세요. 그래야 더 정확한 결과를 얻을 수 있어요.',
        },
      },
      {
        testName: '심전도 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '심전도 검사는 엄마의 심장 박동 리듬과 속도를 살펴, 부정맥이나 심장동맥질환 같은 순환기 질환이 있는지 확인할 수 있어요. 임신 중 심장 건강을 챙기는 중요한 검사이니 꼭 받으시면 좋아요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '병원에서 안내에 따라 침대에 편안히 누워주세요. 피부에 붙일 전극 부위를 알코올 솜으로 닦고, 필요하면 면도를 하기도 한답니다. 전극연고나 젤리를 발라 전극을 붙이면 준비 끝! 검사 동안에는 움직이거나 말하지 않고, 3분 정도 편안하게 안정을 취하시면 돼요.',
            },
          ],
          note: '검사 중 잠시 불편할 수 있지만, 우리 엄마와 아기의 안전을 위한 소중한 시간이랍니다. 모든 과정이 순조롭게 진행되도록 차분한 마음으로 검사에 임해 주세요. 건강한 출산까지 저희가 늘 응원할게요!',
        },
      },
      {
        testName: '흉부 X선 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '출산 예정일이 다가올수록, 엄마의 순환기 및 호흡기 건강 상태를 미리 확인하는 게 정말 중요해요! 흉부 X선 검사는 폐와 심장 상태를 꼼꼼히 살펴, 순환계 질환 여부를 진단하는 대표적인 검사랍니다. 안전한 출산을 위한 필수 점검이니 꼭 받아주세요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '병원에 도착하면 옷을 갈아입으러 탈의실로 안내받으실 거예요. 금속 장식이 있는 옷이나 액세서리(목걸이, 귀걸이, 시계 등)는 검사에 영향을 줄 수 있어 반드시 벗어주세요. 상의를 탈의한 후, 하복부에 납으로 된 보호복을 착용한 뒤 검사가 시작됩니다. 검사는 짧은 시간 내에 끝나며, 특별히 불편하지 않으니 안심하세요!',
            },
          ],
          note: '검사는 엄마와 아기의 안전을 위한 중요한 절차입니다. 불편함이 있을 수 있지만, 건강을 위해 꼭 필요한 과정이니 협조 부탁드려요. 건강한 출산까지 저희가 늘 함께 응원할게요!',
        },
      },
      {
        testName: '혈액 응고 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '혈액 응고 검사는 혈소판과 응고인자의 양과 기능에 이상이 없는지 확인하는 검사입니다. 임신 중 출혈 질환은 산모와 아기 모두에게 위험할 수 있기 때문에, 조기에 발견해 대비하는 것이 중요해요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '혈관에서 소량의 혈액을 채취해 검사합니다. 별도의 준비는 필요 없고, 채혈실에서 간단히 진행됩니다. 주사 자극은 잠깐이며, 경우에 따라 채혈 부위를 5분 정도 지혈할 수 있습니다.',
            },
          ],
          note: '출혈 질환이 있더라도 미리 알면 안전한 분만 계획을 세울 수 있습니다. 검사 결과는 반드시 의료진과 함께 확인하세요.',
        },
      },
      {
        testName: '성병균 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '성병균 검사는 건강한 아기를 맞이하기 위해 꼭 필요한 검사입니다. 특히, 클라미디아균은 조산과 아기의 각막염을 일으킬 수 있고, 유레아플라즈마균은 조산, 사산, 저체중아 출산, 양수양막염을 유발할 수 있으며, 트리코모나스는 태반 조기 박리와 조산 위험을 높이고, 임질은 유산, 조산, 융모양막염, 산욕기 감염을 일으킬 수 있습니다. 마이코플라즈마 제니탈리움은 유산 위험과 관련되어 있어요. 이런 감염을 미리 확인해 치료하는 것이 엄마와 아기 건강에 큰 도움이 될 거예요',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '질경을 넣고, 특수한 브러시로 질 분비물을 부드럽게 채취합니다. 채취한 샘플로 성병균 유무를 검사하게 됩니다. 검사 과정은 짧고 편안하게 진행되니 걱정하지 않으셔도 됩니다.',
            },
          ],
          note: '이 검사는 엄마와 우리 아기를 위해 꼭 필요한 검사예요. 검사 결과가 나오면, 의료진과 함께 차근차근 잘 이야기 나누며 건강한 임신을 이어가길 응원할게요. 너무 걱정하지 말고 마음 편히 검사받으세요.',
        },
      },
      {
        testName: 'GBS 배양 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                'B군용혈연쇄구균(GBS)은 아기의 패혈증과 뇌수막염을 유발할 수 있는 위험한 균이에요. 10~30%의 마미님들께서 이 균을 가지고 계셔서 결코 적은 확률이 아니랍니다. GBS는 하부직장과 질에 살고 있으며, 분만 시 아기에게 심각한 감염을 일으킬 수 있어 조심해야 해요. 검사 결과가 양성일 경우, 진통 중에 예방적 항생제 투약으로 신생아 감염을 예방할 수 있답니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer: '질과 직장에 멸균된 면봉을 살짝 넣어 질 분비물을 채취한 뒤, 이 분비물에서 GBS가 있는지 검사할 거예요.',
            },
          ],
          note: '검사는 엄마와 아기의 안전을 위한 필수 절차입니다. 불편할 수 있지만, 건강한 출산을 위해 꼭 받아주세요.',
        },
      },
    ],
  },
  {
    period: '37~40주',
    category: '분만 준비 및 태동 검사',
    tests: [
      {
        testName: '초음파 검사',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '다시 우리 아기를 볼 시간이 다가왔어요! 우리 아기가 얼마나 컸는지, 체중은 잘 늘고 있는지 궁금하시죠? 초음파 검사를 통해 아기의 모습을 직접 확인하고, 양수 양과 태반 위치도 꼼꼼히 점검할 수 있답니다.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '복부초음파를 통해 아기를 볼 거예요. 배 위 피부에 윤활제를 바르고, 초음파 기구를 움직여 뱃속 아기를 관찰합니다. 병원 안내에 따라 침대에 누워 자세를 취해주시고, 숨을 천천히 들이쉬고 내쉬시면 돼요. 검사 시간은 약 10분 정도이며, 통증 없이 편안하게 받을 수 있답니다.',
            },
          ],
          note: '검사는 아기와 엄마의 건강을 지키기 위한 중요한 과정입니다. 불편함 없이 안전하게 진행되니 안심하세요. 건강한 출산까지 저희가 늘 함께 응원할게요!',
        },
      },
      {
        testName: '태동 검사(NST)',
        details: {
          questions: [
            {
              question: '왜 이 검사가 필요할까요?',
              answer:
                '태동검사(NST)는 아기가 건강하게 잘 있는지, 자궁이 수축된 상태인지 확인하는 중요한 검사예요. 특히 조기 진통이 의심되거나 임신 후반기, 분만 진통 시 꼭 받아야 하며, 마미님의 건강한 출산을 위해 꼭 필요하답니다. 이 검사를 통해 아기의 심박음이 정상인지도 체크할 수 있어요.',
            },
            {
              question: '어떻게 진행되나요?',
              answer:
                '임신 36주부터 분만 시까지 매주 받는 것이 권장되며, 고위험 임신의 경우 32~34주부터 시작할 수 있어요. 배에 밴드를 고정해 자궁수축 감지 장치와 아기 심장 소리 감지 장치를 부착합니다. 아기가 건강하면 움직임에 따라 심박동이 증가하는 파형이 나타난답니다. 검사는 비교적 간단하며, 검사 후에는 편안히 쉬시면 좋아요.',
            },
          ],
          note: '태동검사는 엄마와 아기 건강을 위한 필수 검사입니다. 검사 중 불편함이 거의 없으니 안심하시고, 검사 후에는 충분히 휴식을 취해 주세요.',
        },
      },
    ],
  },
];
